import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../icon";
export default function Triangle(props) {
    return (_jsx(Icon, { ...props, children: _jsx("path", { d: "M10.528 2.283a3 3 0 0 1 4.037 1.058l.003.005 8.47 14.14.008.014a2.999 2.999 0 0 1-2.565 4.5H3.519a3.001 3.001 0 0 1-2.565-4.5l.008-.014 8.47-14.14.858.514-.855-.519a3 3 0 0 1 1.093-1.058Zm.618 2.094L2.683 18.506A1 1 0 0 0 3.536 20h16.928a1 1 0 0 0 .853-1.494L12.855 4.379l-.001-.002a1 1 0 0 0-1.708 0Z" }) }));
}
